import { PermissionT } from "../types";

export const userPartnerRequestAccess = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "user_partner_request_access");
  return !!p;
};

export default userPartnerRequestAccess;
